<div class="frac-fctv-manage-id" *ngIf="updateForm; else loading">
  <form [formGroup]="updateForm" *ngIf="!(contractManagement$$ | async)" (ngSubmit)="doUpdate()">
    <div class="details col">
      <h4>Trucking Vendor</h4>
      <div class="vendor-name-main" *ngIf="fctv$ | async as fctv">{{ fctv.truckingVendorName }}</div>
      <h4>Contract</h4>
      <div class="contract-container">
        <sa-filtered-autocomplete
          [formControl]="contractForm"
          [selectOptions]="vendorContracts$ | async"
          [displayFn]="vendorDisplayFn"
          placeholderText="Select Contract"
          saAutomatedSelector="fctv_manage__contract"
        ></sa-filtered-autocomplete>
        <ng-container *saUserPermission="'trucking_contract_manager'">
          <button type="button" color="primary" mat-mini-fab (click)="createNewContract()">
            <mat-icon>add</mat-icon>
          </button>
        </ng-container>
      </div>
      <h4 class="trailer-type-contract">
        <h4 class="trailer-type-contract-label">Trailer Type Contracts</h4>
        <h4 class="trailer-type-contract-label add-button cursor-pointer" (click)="openCreateTrailerTypeContract()">
          Add
        </h4>
      </h4>
      <div
        class="trailer-type-contract"
        *ngFor="let trailerTypeContract of trailerTypeContracts$ | async; trackBy: trackByTrailerTypeContract"
        [value]="trailerTypeContract.id"
      >
        <h4 class="trailer-type-name cursor-pointer" (click)="openEditTrailerTypeContract(trailerTypeContract)">
          {{ trailerTypeContract.trailerTypeContractDisplayName }}
        </h4>
        <div class="contract-name">
          <h4>{{ trailerTypeContract.vendorContractName }}</h4>
          <h4>
            <i class="material-icons delete-icon cursor-pointer" (click)="openDeleteConfirmation(trailerTypeContract)"
              >close</i
            >
          </h4>
        </div>
      </div>
      <h4>Job Details</h4>
      <div class="job-details">
        <mat-form-field class="form-field">
          <input
            matInput
            class="datepicker-input"
            placeholder="Valid Dates"
            autocomplete="off"
            formControlName="dates"
            [owlDateTime]="dates"
            [owlDateTimeTrigger]="dates"
            [selectMode]="'range'"
            [max]="maxDate"
            saAutomatedSelector="fctv_manage__dates"
          />
          <span [owlDateTimeTrigger]="dates"><i class="material-icons">calendar_today</i></span>
          <owl-date-time #dates [pickerType]="'calendar'"></owl-date-time>
        </mat-form-field>
        <mat-form-field class="form-field">
          <textarea
            matInput
            placeholder="Description"
            autocomplete="off"
            formControlName="description"
            saAutomatedSelector="fctv_manage__description"
          ></textarea>
        </mat-form-field>
      </div>
    </div>
    <div class="distribution col">
      <h4>Work Distribution</h4>
      <ng-container
        *ngFor="
          let distribution of distributions.controls;
          let i = index;
          trackBy: distributions.controls | trackByKey: null
        "
        formArrayName="distributions"
      >
        <div class="vendor-distribution" [formGroupName]="i">
          <span class="vendor-name">{{
            getVendorNameFromId$(distribution.get('fracClusterTruckingVendorId').value) | async
          }}</span>
          <mat-form-field>
            <input
              matInput
              type="number"
              placeholder="Percent"
              formControlName="allocationPercent"
              autocomplete="off"
              saAutomatedSelector="fctv_manage__distribution"
              [automatedName]="getVendorNameFromId$(distribution.get('fracClusterTruckingVendorId').value) | async"
            />
          </mat-form-field>
        </div>
      </ng-container>
      <div class="actions">
        <button
          class="cancel"
          mat-stroked-button
          color="warn"
          type="button"
          (click)="cancel()"
          saAutomatedSelector="fctv_manage__cancel"
        >
          {{ cancelButtonText$ | async }}
        </button>
        <button
          class="update"
          mat-raised-button
          color="primary"
          type="submit"
          saAutomatedSelector="fctv_manage__submit"
        >
          Update Vendor Request
        </button>
      </div>
    </div>
  </form>
  <div class="contract-management" *ngIf="contractManagement$$ | async">
    <button mat-icon-button (click)="cancelContractChoice()"><mat-icon>close</mat-icon></button>
    <h3>Vendor Contract</h3>
    <sa-lmo-frac-fctv-contract-addedit
      [contract]="contractForm.value"
      [vendor]="vendor$ | async"
      [formControl]="updateForm.get('contract')"
    ></sa-lmo-frac-fctv-contract-addedit>
  </div>
</div>

<ng-template #confirmCancel>
  <ng-container *ngIf="fctv$ | async as fctv">
    <h1 mat-dialog-title>{{ cancelButtonText$ | async }}</h1>
    <div mat-dialog-content>
      <p>Are you sure you want to remove {{ fctv.truckingVendorName }} from {{ fctv.fracClusterName }}</p>
    </div>
    <div mat-dialog-actions class="actions">
      <button mat-button [mat-dialog-close]="false" color="primary" saAutomatedSelector="choice-dialog__cancel-action">
        Go Back
      </button>
      <button mat-button [mat-dialog-close]="true" color="warn" saAutomatedSelector="choice-dialog__continue-action">
        {{ cancelButtonText$ | async }}
      </button>
    </div>
  </ng-container>
</ng-template>

<ng-template #loading>
  <div class="loading">
    <mat-spinner></mat-spinner>
  </div>
</ng-template>

<ng-template #confirmDeleteTrailerTypeContract>
  <ng-container>
    <h1 mat-dialog-title>
      Remove {{ selectedToDelete$.value.trailerTypeContractDisplayName }} -
      {{ selectedToDelete$.value.vendorContractName }}
    </h1>
    <div mat-dialog-content>
      <p>Are you sure you want to remove?</p>
    </div>
    <div mat-dialog-actions class="actions">
      <button mat-button [mat-dialog-close]="false" color="primary" saAutomatedSelector="choice-dialog__cancel-action">
        Cancel
      </button>
      <button mat-button [mat-dialog-close]="true" color="warn" saAutomatedSelector="choice-dialog__continue-action">
        Yes
      </button>
    </div>
  </ng-container>
</ng-template>
